import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { loadAllOrderInd } from "../thunks/loadAllOrderInd";
import { OrderIndListData } from "../types";
import { PageData } from "../../../models";
import { invalidateorderInd } from "../orderIndDataReducer";


export const useOrderIndData = () => {

//  const data = useSelector<StoreType, OrderIndListData[] | undefined>(
//    (s) => s.data.trading.orderind.currentPage?.currentPageData
//  );

  const allData = useSelector<StoreType, OrderIndListData[] | undefined>(
    (s) => s.data.trading.orderind.currentPage?.currentPageData
  );

  const data = useSelector<StoreType, PageData<OrderIndListData> | undefined>(
    (s) => s.data.trading.orderind.currentPage
  );
  const dispatch = useDispatch();
  const dispatchLoadOrderIndPage = React.useCallback(
    () => dispatch(loadAllOrderInd()),
    [dispatch]
  );

  const dispatchInvalidate = React.useCallback(() => dispatch(invalidateorderInd()), [dispatch]);

  return [data, dispatchLoadOrderIndPage, allData, dispatchInvalidate] as [
    typeof data,
    typeof dispatchLoadOrderIndPage,
    typeof allData,
    typeof dispatchInvalidate

  ];
};
